import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css'; // keep this if you need it
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router } from 'react-router-dom'; // <-- import HashRouter

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
    <Router> {/* <-- wrap your App in HashRouter */}
      <App />
    </Router>
  
);

reportWebVitals();
